import HomeValuation from 'components/home-valuation';
import ValuationLayout from 'components/layout/valuation-layout';

export default function FreeHomeValuation() {
  return (
    <ValuationLayout>
      <HomeValuation />
    </ValuationLayout>
  );
}
